<template>
  <v-select
    :readonly="readonly"
    v-model="selectedValue"
    :items="options"
    item-text="label"
    item-value="value"
    :label="label"
    :no-data-text="$t('labels.dropdownNoData')"
  ></v-select>
</template>

<script>
import handle_session_error from '@/helpers/handle_session_error.js'

export default {
  name: 'Dropdown',
  props: ['readonly', 'value', 'ajax', 'data', 'label'],
  data() {
    return {
      endpoint: '',
      selectedValue: null,
      options: [],
      ajaxLoaded: false,
    }
  },
  watch: {
    value: function (newVal, oldVal) {
      if (newVal != oldVal) {
        if (newVal != null) {
          if (this.selectedValue != null) {
            if (this.selectedValue.value != newVal) {
              this.setValue(newVal)
            }
          } else {
            this.setValue(newVal)
          }
        } else {
          this.selectedValue = null
        }
      }
    },
    selectedValue: function (val) {
      if (val != null) {
        if (val != this.$props.value) {
          this.$nextTick(() => {
            this.$emit('input', val)
          })
        }
      } else {
        this.$nextTick(() => {
          this.$emit('input', null)
        })
      }
    },
  },
  methods: {
    setValue(newVal) {
      if (this.$props.ajax) {
        if (!this.ajaxLoaded) {
          this.$APICall(
            'get',
            'SELECT',
            '/' + this.endpoint,
            [],
            data => {
              this.options = data.otherEvents
              this.ajaxLoaded = true
              this.selectedValue = newVal
            },
            true,
            error => {
              handle_session_error(
                error,
                this.$store,
                this.$router,
                this.$prompt
              )
            }
          )
        } else {
          this.selectedValue = newVal
        }
      } else {
        this.options = this.$props.data
        this.selectedValue = newVal
      }
    },
  },
  mounted() {
    if (this.$props.ajax) {
      this.endpoint = this.$props.data
    }
    this.setValue(this.$props.value)
  },
}
</script>
